/*
  Fuego & Fragancia — idioma automático según el dispositivo.

  CÓMO SE REPARTE EL TRABAJO CON EL AVISO DE IDIOMA
  Hay dos marcas distintas y no una sola, y la diferencia importa:

    ff_locale_choice → el visitante DECIDIÓ (pulsó un idioma o cerró el aviso).
                       A partir de ahí este script no vuelve a moverlo nunca.
    ff_locale_auto   → este script ya evaluó una vez en esta visita.

  Con una sola marca pasaba lo siguiente: el visitante elegía inglés a mano y
  en la página siguiente la detección automática volvía a mandarlo al español,
  porque para ella "aún no se había decidido nada". Un bucle del que no se
  sale. Con las dos marcas, la decisión manual siempre gana.

  Cookies y no localStorage: la cookie sobrevive a la vuelta desde el checkout,
  que está en otro dominio, y es lo que el encargo pedía para que un visitante
  que regresa no tenga que volver a elegir.

  CAMBIA EL IDIOMA, NO EL PAÍS
  Del país se encarga Shopify con sus mercados (moneda, envíos, impuestos).
  Aquí solo se salta entre los idiomas que el mercado actual ya declara, así
  que nadie acaba en la tienda de otro país por tener el móvil en inglés.

  Escape para auditar: añadir ?ff_nolocale=1 a la URL.
*/
(function () {
  const el = document.getElementById('ff-locale-data');
  if (!el) return;

  let data;
  try {
    data = JSON.parse(el.textContent);
  } catch (e) {
    return;
  }

  if (!data.enabled || !Array.isArray(data.languages) || data.languages.length < 2) return;

    /*
    Compone la misma pagina en otro idioma. Devuelve cadena vacia si el
    resultado seria la URL actual: asi es imposible entrar en un bucle de
    redirecciones, por mal que salgan las cuentas.
  */
  function construirUrl(raizDestino) {
    var raiz = raizDestino === '/' ? '' : raizDestino;
    var raizActual = data.currentRoot === '/' ? '' : data.currentRoot;

    var ruta = window.location.pathname;
    if (raizActual && ruta.indexOf(raizActual) === 0) {
      ruta = ruta.slice(raizActual.length) || '/';
    }

    var url = raiz + ruta + window.location.search + window.location.hash;
    var actual = window.location.pathname + window.location.search + window.location.hash;
    return url === actual ? '' : url;
  }

  /*
    Se lee partiendo la cadena y no con una expresion regular, y hay motivo.

    Aqui vivia un patron que pretendia decir "punto y coma y espacios" pero
    perdio la barra por el camino y acabo pidiendo eses: (?:^|;s*). Con eso la
    cookie solo aparecia cuando era LA PRIMERA de document.cookie, porque el
    separador real entre cookies es punto y coma mas ESPACIO.

    En una tienda Shopify siempre hay cookies antes que las nuestras
    (_shopify_essential, cart, localization...), asi que la eleccion del
    visitante se leia vacia casi siempre: la deteccion automatica creia que
    nadie habia elegido nada y lo devolvia al idioma del dispositivo en la
    pagina siguiente. Ese era el rebote que no habia forma de cazar.

    Partir por el punto y coma no tiene escapadas que se puedan perder.
  */
  function leerCookie(nombre) {
    var trozos = document.cookie ? document.cookie.split(String.fromCharCode(59)) : [];
    for (var i = 0; i < trozos.length; i += 1) {
      var trozo = trozos[i].trim();
      if (trozo.indexOf(nombre + "=") === 0) {
        var crudo = trozo.slice(nombre.length + 1);
        try {
          return decodeURIComponent(crudo);
        } catch (e) {
          return crudo;
        }
      }
    }
    return "";
  }

  function guardarCookie(nombre, valor) {
    document.cookie =
      nombre + '=' + encodeURIComponent(valor) + ';path=/;max-age=' + 60 * 60 * 24 * 365 + ';SameSite=Lax';
  }

  /*
    ---------- La eleccion llega por la URL ----------

    Cuando el visitante elige idioma en el aviso, el enlace de destino trae
    ?ff_lang=xx. Aqui se convierte en cookie, YA EN DESTINO.

    Es la unica forma de que no rebote. Escribir la cookie antes de navegar
    no basta: el navegador puede lanzar la peticion antes de guardarla, la
    pagina nueva carga sin la marca, y esta deteccion la ve como una visita
    virgen y devuelve al visitante a su idioma de dispositivo. Con el dato
    dentro de la propia peticion no hay carrera que perder.
  */
  var parametros = new URLSearchParams(window.location.search);
  var elegido = parametros.get('ff_lang');
  if (elegido) {
    guardarCookie('ff_locale_choice', elegido);
    guardarCookie('ff_locale_auto', '1');

    // Se limpia el parametro para no dejarlo pegado en la barra ni en los
    // enlaces que el visitante comparta despues.
    parametros.delete('ff_lang');
    var cola = parametros.toString();
    var limpia = window.location.pathname + (cola ? '?' + cola : '') + window.location.hash;
    try {
      window.history.replaceState({}, '', limpia);
    } catch (e) {}

    return; // en esta carga no se redirige jamas
  }

  if (window.location.search.indexOf('ff_nolocale=1') !== -1) {
    guardarCookie('ff_locale_choice', 'audit');
    return;
  }

  /*
    ---------- La eleccion manda, en TODAS las paginas ----------

    No basta con "si ya eligio, no lo toques": hay que comprobar que la pagina
    que esta viendo es la de SU idioma, y llevarlo alli si no lo es.

    Por que: si un solo enlace del sitio pierde el prefijo de idioma, ese clic
    deja al visitante en el idioma por defecto del mercado y su eleccion se
    evapora. El prefijo se arregla al construir el HTML (ver snippets/ff-url),
    pero esto es la red que recoge cualquier enlace que se escape: los de
    texto enriquecido, los de secciones heredadas, los que escriba alguien
    manana. Con esto la preferencia es una garantia, no una esperanza.
  */
  var eleccion = leerCookie('ff_locale_choice');
  if (eleccion) {
    // "dismissed" y "audit" significan "dejame en paz", no un idioma.
    if (eleccion === 'dismissed' || eleccion === 'audit') return;
    if (eleccion === data.current) return;

    var suIdioma = data.languages.find(function (l) { return l.iso === eleccion; });
    if (!suIdioma) return; // el idioma ya no existe en este mercado

    var destinoUrl = construirUrl(suIdioma.root);
    if (destinoUrl) window.location.replace(destinoUrl);
    return;
  }


  /*
    NO se comprueba la cookie "localization" de Shopify, y merece una nota
    porque estuvo aquí y hubo que quitarla.

    Parecía una buena red de seguridad, pero Shopify crea esa cookie por su
    cuenta en visitas normales, no solo cuando alguien usa el selector. Con
    ella puesta, la detección por idioma de dispositivo quedaba desactivada
    para todo el mundo desde la primera página.

    La única señal fiable de "este visitante decidió" es nuestra cookie, y se
    escribe antes de navegar (ver ff-lang-prompt.js), así que llega siempre.
  */

  // Ya se evaluó en esta visita.
  if (leerCookie('ff_locale_auto')) return;

  const preferidos =
    navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
  if (!preferidos || !preferidos[0]) return;

  // Se compara solo la parte de idioma: "es-419", "es-CO" y "es" son español.
  const base = (tag) => String(tag || '').toLowerCase().split('-')[0];

  // Se recorre la lista de preferencias del navegador en orden: si alguien
  // tiene [fr, es, en], se le da español antes que inglés.
  let destino = null;
  for (let i = 0; i < preferidos.length && !destino; i += 1) {
    const quiere = base(preferidos[i]);
    destino = data.languages.find((l) => base(l.iso) === quiere) || null;
  }

  // Se marca pase lo que pase: si el idioma del dispositivo ya es el que se
  // está viendo, tampoco hace falta volver a evaluarlo en cada página.
  guardarCookie('ff_locale_auto', '1');

  if (!destino || destino.iso === data.current) return;

  const raiz = destino.root === '/' ? '' : destino.root;
  const raizActual = data.currentRoot === '/' ? '' : data.currentRoot;

  let ruta = window.location.pathname;
  if (raizActual && ruta.indexOf(raizActual) === 0) {
    ruta = ruta.slice(raizActual.length) || '/';
  }

  const url = raiz + ruta + window.location.search + window.location.hash;
  if (url === window.location.pathname + window.location.search + window.location.hash) return;

  window.location.replace(url);
})();
